import { authService } from '../services'
import Vue from 'vue'

const user = JSON.parse(localStorage.getItem('user'))
const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: { username: null } }

const actions = {
  login ({ commit }, { username, password, redirectTo }) {
    commit('loginRequest', { username })

    return authService.login(username, password)
      .then(
        user => {
          commit('loginSuccess', user)

          // Store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('user', JSON.stringify(user))
          return user.result
        },
        error => {
          commit('loginFailure', error)
          return Promise.reject(error)
        }
      )
  },

  logout ({ commit }) {
    authService.logout()
    commit('logout')
  },

  generateToken ({ commit, dispatch }, { email }) {
    commit('generateTokenRequest', { email })

    return authService.generateToken(email)
      .then(user => {
        commit('generateTokenSuccess')
        return user.result
      }).catch(error => {
        commit('resetPasswordSuccess')
        return Promise.reject(error)
      })
  },

  resetPassword ({commit, dispatch}, { token, password }) {
    commit('resetPasswordRequest', { token, password })

    return authService.resetPassword(token, password)
      .then(user => {
        return user.result
      }).catch(error => {
        console.error(error)
        return Promise.reject(error)
      })
  }
}

const mutations = {
  loginRequest (state, user) {
    state.status = { loggingIn: true }
    state.user = user
  },

  loginSuccess (state, user) {
    state.status = { loggedIn: true }
    state.user = user
  },

  loginFailure (state) {
    state.status = {}
    state.user = null
  },

  logout (state) {
    state.status = {}
    state.user = null
  },
  generateTokenRequest (state, user) {
    state.user = user
  },
  generateTokenSuccess (state, user) {
    Vue.prototype.$toast('En återställningslänk har skickats till din email', 'info')
  },
  resetPasswordRequest (state, user) {
    state.user = user
  },
  resetPasswordSuccess (state, user) {
    Vue.prototype.$toast('Lösenordet är återställt', 'success')
  }
}

const getters = {
  hasPermission: (state, getters) => (permissions) => {
    if (!state) {
      return false
    }

    if (!getters.hasRole('Staff')) {
      return false
    }

    if (!Array.isArray(permissions)) {
      permissions = [permissions]
    }

    return permissions.some(x => state.user.permissions.includes(x))
  },

  hasRole: (state) => (roles) => {
    if (!state) {
      return false
    }

    if (!Array.isArray(roles)) {
      roles = [roles]
    }
    return roles.includes(state.user.role)
  }
}

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/auth.module.js